import { SequenceManagerAction } from "../actions/SequenceManagerAction";
import { ProductOfferAction } from "../actions/ProductOfferAction";
import { SimOptionAction } from "../actions/SimOptionAction";
import { NumberOptionAction } from "../actions/NumberOptionAction";
import { ChooseNumberAction } from "../actions/ChooseNumberAction";
import { CurrentOperatorAction } from "../actions/CurrentOperatorAction";
import { CurrentNumberAction } from '../actions/CurrentNumberAction'
import '../local';
import ConfigData from '../EcommerceConfig.json';

const win: any = window;
let dir = win["lang"] === null || win["lang"] === "en" ? "ltr" : "rtl";
const lang = win["lang"];
const rtl = lang === "ar";

const skipIVR = new URL(window.location.href).searchParams.get("skipivr");
const initState = {
    rtl: rtl,
    dir: dir,
    lang: lang,
    sectionsVisited: [],
    sectionToShow: '',
    appState: '',
    productKey: '',
    productURL: '',
    productType: 'V',
    journey: '',
    planType: '',
    error: {},
    structure: '',
    selectedProduct: '',
    selectedProductLabel: '',
    selectedSimType: '',
    selectedMsisdn: '',
    selectedMsisdnType: 'Normal number',
    selectedTier: '',
    productExternalId: '',
    operator: 'Mobily',
    orderType: '',
    orderId: '',
    orderStatus: '',
    paymentTransactionId: '',
    tccToken: '',
    payType: '',
    nationCode: '',
    channel: { href: "", id: "bo_lov_portals", name: "Portals", role: "" },
    category: {},
    email: "",
    maskedEmail: "",
    isIVRRequired: !(skipIVR === 'true'),
    xCorrelationId: win["x_cor_id"],
    // xTransactionIds: win["x_trans_id"],
    journeyName: 'Pre_Journey',
    nafathStatus: '',
    isBundle: false,
    captureDataResponse:{},
    generalErrModal: false,
    generalErrRes: {}
}
const getCategory = (category: any) => {
    switch (category) {
        case 'sim':
            return { id: "mobile-pc_laf6x", name: "Mobile" };

        case 'internet':
            return { id: "home_internet_-pc_fb4tm_v1", name: "Home Internet" };
    }
}

const getOrderType = (journey: any) => {
    let orderType = '';
    if (journey === "UPGRADE_SIM" || journey === "REPLACE_SIM") {
        orderType = "Sim SWAP";
    } else if (journey === "COLD_SSA") {
        orderType = "Cold SSA";
    } else if (journey === "MNP") {
        orderType = "MNP";
    } else if (journey?.includes("FTTH")) {
        orderType = "FTTH";
    } else {
        orderType = "Activation";
    }
    return orderType;
}

const getJourneyName = (journey: any, selectedSimType: any) => {
    // NEW_NUMBER_SIM, NEW_NUMBER_eSIM, KEEP_NUMBER_SIM, KEEP_NUMBER_eSIM, Cold_SSA, Sim SWAP_SIM, Sim SWAP_eSIM, MNP_ACTIVATION_CANCEL 
    let simVal = selectedSimType === '' || selectedSimType === 'Not Required' ? '' : selectedSimType;
    switch (journey) {
        case 'NEW_SIM':
            return simVal === '' ? 'Pre_Journey' : (selectedSimType === "eSIM" ? "NEW_NUMBER_eSIM" : "PreSSA");

        case 'ESIM':
            return "NEW_NUMBER_eSIM";

        case 'MNP':
            return simVal === '' ? 'Pre_Journey' : (selectedSimType === "eSIM" ? "KEEP_NUMBER_eSIM" : "KEEP_NUMBER_SIM");

        case 'COLD_SSA':
            return "Cold_SSA";

        case 'UPGRADE_SIM':
            return "Sim SWAP_eSIM";

        case 'REPLACE_SIM':
            return simVal === '' ? 'Pre_Journey' : (selectedSimType === "eSIM" ? "Sim SWAP_eSIM" : "Sim SWAP_SIM");

        case 'FTTH':
            return "FTTH";

        case 'FTTH_6:Month':
            return "FTTH";

        case 'FTTH_12:Month':
            return "FTTH";
    }
}


const SequenceManagerReducer = (state: any = initState, action: any) => {
    const { type } = action;
    const { payload } = action;

    switch (type) {
        case SequenceManagerAction.INIT:
        case SequenceManagerAction.SET_PRODUCT_KEY_COMPLETE:
        case SequenceManagerAction.LOAD_PRODUCT_OFFER_COMPLETE:
        case SequenceManagerAction.CREATE_SHOPPING_CART_COMPLETE:
        case SequenceManagerAction.QUALIFY_PRODUCTS_COMPLETE:
        case SequenceManagerAction.SHOPPING_CART_PATCH_SIGNATURE_COMPLETE:
        case SequenceManagerAction.SHOPPING_CART_VALIDATION_COMPLETE:
        case SequenceManagerAction.UPDATE_VALIDATE_CART_COMPLETE:
        case SequenceManagerAction.SHOPPING_CART_UPDATE_COMPLETE:
        case SequenceManagerAction.STRUCTURE_UPDATE_COMPLETE:
        case SequenceManagerAction.GET_CHECKOUT_COMPLETE:
        case SequenceManagerAction.CREATE_ORDER_COMPLETE:
        case SequenceManagerAction.CAPTURE_DATA_COMPLETE:
        case SequenceManagerAction.DISPLAY_NEXT_SECTION:
            return { ...state, appState: type }

        case SequenceManagerAction.SET_PRODUCT_KEY:
            return {
                ...state, appState: type,
                journey: payload?.journey,
                orderType: getOrderType(payload?.journey),
                category: getCategory(payload?.productCategory),
                productKey: payload?.productKey,
                planType: payload?.planType,
                productURL: payload?.productURL,
                journeyName: getJourneyName(payload?.journey, state.selectedSimType)
            }

        case SequenceManagerAction.STRUCTURE_UPDATE_SUCCESS:
            return { ...state, structure: payload }

        case SequenceManagerAction.SECTION_COMPLETE:
            return {
                ...state, appState: type,
                sectionsVisited: [...state.sectionsVisited, ...payload]
            }

        case SequenceManagerAction.DISPLAY_PREVIOUS_SECTION:
            return {
                ...state, appState: type,
                sectionsVisited: [...state.sectionsVisited.slice(0, state.sectionsVisited.length - payload)]
            }

        case SequenceManagerAction.DISPLAY_SECTION:
            let sections = state.structure.sections.map((section: any) => section.sectionId);
            let sects = sections.map((section: any) => {
                return (
                    ConfigData.section_mappings.filter((sect: any) => {
                        return (sect.checkoutSectionId === section)
                    })[0].section
                )
            })
            console.log(sects.slice(0, sects.indexOf(payload.section)));
            return {
                ...state, appState: type,
                sectionToShow: payload.section,
                tccToken: payload.params.tccToken ? payload.params.tccToken : state.tccToken,
                productKey: payload.params.productKey ? payload.params.productKey : state.productKey,
                productURL: payload.params.productURL ? payload.params.productURL : state.productURL,
                orderType: payload.params.journey ? getOrderType(payload.params.journey) : state.orderType,
                journey: payload.params.journey ? payload.params.journey : state.journey,
                planType: payload.params.planType ? payload.params.planType : state.planType,
                productType: payload.params.productType ? payload.params.productType : state.productType,
                operator: payload.params.operator ? payload.params.operator : state.operator,
                category: payload.params.productCategory ? getCategory(payload.params.productCategory) : state.category,
                selectedProduct: payload.params.selectedProduct ? payload.params.selectedProduct : state.selectedProduct,
                selectedProductLabel: payload.params.selectedProductLabel ? payload.params.selectedProductLabel : state.selectedProductLabel,
                selectedSimType: payload.params.selectedSimType ? payload.params.selectedSimType : state.selectedSimType,
                productExternalId: payload.params.productExternalId ? payload.params.productExternalId : state.productExternalId,
                orderId: payload.params.orderId ? payload.params.orderId : state.orderId,
                sectionsVisited: sects.slice(0, sects.indexOf(payload.section)),
                selectedMsisdn: payload.params.selectedMsisdn ? payload.params.selectedMsisdn : state.selectedMsisdn,
                selectedMsisdnType: payload.params.selectedMsisdnType ? payload.params.selectedMsisdnType : state.selectedMsisdnType,
                selectedTier: payload.params.selectedTier ? payload.params.selectedTier : state.selectedTier,
                payType: payload.params.payType ? payload.params.payType : state.payType,
                nationCode: payload.params.nationCode ? payload.params.nationCode : state.nationCode,
                email: payload.params.email ? payload.params.email : state.email,
                maskedEmail: payload.params.maskedEmail ? payload.params.maskedEmail : state.maskedEmail,
                xCorrelationId: payload.params.xCorrelationId ? payload.params.xCorrelationId : state.xCorrelationId,
                // xTransactionIds: payload.params.xTransactionIds? payload.params.xTransactionIds : state.xTransactionIds,
                journeyName: payload.params.journeyName ? payload.params.journeyName : state.journeyName,
                nafathStatus: payload.params.nafathStatus ? payload.params.nafathStatus : state.nafathStatus,
            }

        case ProductOfferAction.LOAD_PRODUCT_OFFER_SUCCESS:
            // this product name is to display arabic and english name
            let productName = "";
            if (state.lang === 'ar' && payload.response?.data?.getProductOfferByID[0].offerLabels.length > 0) {
                productName = payload.response?.data?.getProductOfferByID[0].offerLabels[0].name;
            } else {
                productName = payload.response?.data?.getProductOfferByID[0].name;
            }
            return {
                ...state, selectedProductLabel: productName,
                selectedProduct: payload.response?.data?.getProductOfferByID[0].name,
                productExternalId: payload.response?.data?.getProductOfferByID[0].externalID,
                isBundle: payload.response?.data?.getProductOfferByID[0]?.isBundle
            }

        case NumberOptionAction.MAKE_SELECTION:
            return {
                ...state, journey: payload.selection === 'KEEP_NUMBER' ? 'MNP' : state.journey,
                orderType: payload.selection === 'KEEP_NUMBER' ? "MNP" : "Activation"
            }

        case ChooseNumberAction.RESERVE_MSISDN_SUCCESS:
            return {
                ...state, productType: payload.productType,
                selectedMsisdn: payload.selectedNumber,
                selectedMsisdnType: payload.numberType,
                selectedTier: payload.tier
            }

        case SimOptionAction.SELECT_SIM_TYPE:
            return {...state, selectedSimType: payload.selection,
                              ...payload.selection === 'SIM' && state.journey === "NEW_SIM" ? {orderType: 'PreSSA'} : {},
                              journeyName: getJourneyName(state.journey, payload.selection)
                    }

        case CurrentOperatorAction.SELECT_OPERATOR:
            return { ...state, operator: payload.selection }

        case CurrentNumberAction.GET_CUSTOMER_DETAILS_SUCCESS:
            return {
                ...state, payType: payload?.data?.PayType,
                nationCode: payload?.data?.Nationality,
                email: payload?.data?.Email,
                maskedEmail: payload?.data?.MaskedEmail
            }

        case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
            let section = payload.sections.filter((section: any) => {
                return (section.sectionId === 'SimOption')
            });
            return { ...state, selectedSimType: section[0] ? section[0].steps[0].options[0].value : state.selectedSimType }

        case SequenceManagerAction.GENERATE_ORDER_SUCCESS:
            return { ...state, paymentTransactionId: payload.response?.data?.paymentTransactionId, orderId: payload.response?.data?.orderId, orderStatus: payload.response.status }

        case SequenceManagerAction.CREATE_ORDER_SUCCESS:
            return { ...state, orderId: payload.response.data }

        case SequenceManagerAction.SHOPPING_CART_SIM_TYPE:
            return { ...state, selectedSimType: payload }

        case SequenceManagerAction.GENERIC_ERROR:
            return { ...state, appState: type, error: payload }

        case SequenceManagerAction.CAPTURE_DATA_SUCCESS:
            return { ...state, captureDataResponse: payload }
        case SequenceManagerAction.GENERAL_ERROR_MODAL:
            return { ...state, ...payload}
        default:
            return state;
    }
}

export default SequenceManagerReducer;
